import { IconProps } from './types';

export const TagIcon = ({ title = 'Tag Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="42" fill="none" viewBox="0 0 31 42" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            fillRule="evenodd"
            d="M6.26 13.145 20.193 5.1a1.625 1.625 0 0 1 2.22.595l8.043 13.932c.216.373.274.816.163 1.233l-5.083 18.97a1.625 1.625 0 0 1-1.99 1.149L1.568 35.092a1.625 1.625 0 0 1-1.149-1.99l5.083-18.97c.112-.417.384-.772.758-.987m11.975 3.7a3.25 3.25 0 1 0 1.682-6.278 3.25 3.25 0 0 0-1.682 6.279"
            clipRule="evenodd"
        ></path>
        <path
            fill="#0A2F73"
            fillRule="evenodd"
            d="M22.23 1.934a5.687 5.687 0 1 0-2.944 10.988.813.813 0 0 1-.42 1.57 7.313 7.313 0 1 1 8.956-5.171.813.813 0 0 1-1.57-.421 5.687 5.687 0 0 0-4.022-6.966"
            clipRule="evenodd"
        ></path>
        <path
            fill="#FB0"
            fillRule="evenodd"
            d="M11.115 18.303a4.06 4.06 0 0 0-4.975 2.872l-1.262 4.71a4.062 4.062 0 0 0 7.848 2.102l1.262-4.709a4.063 4.063 0 0 0-2.873-4.975m-3.406 3.293a2.438 2.438 0 0 1 4.709 1.262l-1.262 4.708a2.438 2.438 0 0 1-4.709-1.261z"
            clipRule="evenodd"
        ></path>
        <path
            fill="#FB0"
            d="M24.247 22.662a3.25 3.25 0 0 0-3.98 2.298l-.842 3.14-.785-.21a.813.813 0 0 0-.42 1.569l.784.21-.63 2.355-.785-.21a.812.812 0 1 0-.42 1.57l6.278 1.681a.812.812 0 1 0 .42-1.57l-3.924-1.05.631-2.355 2.354.63a.813.813 0 0 0 .421-1.569l-2.354-.63.84-3.14a1.625 1.625 0 0 1 3.14.841.812.812 0 1 0 1.57.42 3.25 3.25 0 0 0-2.298-3.98M16.917 24.904a.812.812 0 1 1-1.57-.42.812.812 0 0 1 1.57.42M16.076 28.043a.813.813 0 1 1-1.57-.42.813.813 0 0 1 1.57.42"
        ></path>
    </svg>
);
